module.exports = __webpack_public_path__ + "img/logo.bc8cb2c8.png";